module.exports = __webpack_public_path__ + "static/media/sandp.373daaa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/sandp.png
// module id = 569
// module chunks = 0